import { useParams } from "react-router";
import React from "react";
import FusePageCarded from "@fuse/core/FusePageCarded";
import { Stack } from "@mui/system";
import Alert from "@mui/material/Alert";
import VetProfile from "./components/VetProfile/VetProfile";
import VetProfileHeader from "./components/VetProfile/VetProfileHeader";
import { Button } from "@mui/material";
import useVetProfile from "./useVetProfile";

function VetProfileApp() {
	const params = useParams();
	const siteId = params.id;
	const { vet, loading, error, retry } = useVetProfile(siteId);

	return (
		<React.Fragment>
			<FusePageCarded
				header={<VetProfileHeader vet={vet || { name: "Veterinarian" }} />}
				content={
					<>
						<div className="flex w-full p-16 sm:p-24">
							{error && (
								<Stack className="pb-12" sx={{ width: "100%" }} spacing={2}>
									<Alert severity="error" action={<Button color="inherit" onClick={retry}>Retry</Button>}>
										{error}
									</Alert>
								</Stack>
							)}

							{loading && <p role="status">Loading veterinarian...</p>}
							{vet && (
								<VetProfile vet={vet} />
							)}
						</div>

					</>
				}
			/>
		</React.Fragment>
	);
}

export default VetProfileApp;
